import { useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { TextInput } from '@calendly/ui/components/text-input';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState, forwardRef } from 'react';
import { useDebounce } from 'hooks/useDebounce';
import { useIsMounted } from 'hooks/useIsMounted';
import { useFieldStatus } from './use-field-status';
import { ValidationStatus } from './validation-status';
const containerCss = "cs77yl2";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const rootURLCss = "r52sby3";
const RootURL = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(rootURLCss, props.className)}>
      calendly.com/
    </Component>;
});
const styledTextInputCss = "skld3y7";
const StyledTextInput = forwardRef((props, ref) => <TextInput ref={ref} {...props} className={classNames(styledTextInputCss, props.className)} />);
const statusContainerCss = "s18xdr4a";
const StatusContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(statusContainerCss, props.className)} />;
});
export const SlugField = props => {
  const inputRef = useRef(null);
  const {
    validateField
  } = useFormContext();
  const [fieldProps, meta, {
    setValue,
    setTouched
  }] = useFormField(props);
  const errors = meta.touched && meta.error ? [meta.error].flat() : [];
  const [inputSelection, setInputSelection] = useState([0, 0]);
  const [fieldStatus = {}, setFieldStatus] = useFieldStatus(props);
  const {
    showValidationStatus = false
  } = fieldStatus;
  const {
    isValidating: formIsValidating
  } = useFormContext();
  const isMounted = useIsMounted();
  const debouncedValue = useDebounce(fieldProps.value, 500);
  useEffect(() => {
    if (!isMounted.current) return;
    if (!meta.touched) return;
    validateField(fieldProps.name);
    setFieldStatus({
      showValidationStatus: true
    });
  }, [debouncedValue, fieldProps.name, isMounted, meta.touched, setFieldStatus, validateField]);
  const onChange = useCallback(({
    target: {
      value
    }
  }) => {
    const start = inputRef.current.selectionStart;
    const end = inputRef.current.selectionEnd;
    setValue(value.replace(/\s/g, '-').toLowerCase());
    setInputSelection([start, end]);
    setTouched(true, false);
  }, [setTouched, setValue]);
  const onFocus = () => {
    setFieldStatus({
      showValidationStatus: false
    });
  };
  useEffect(() => {
    inputRef.current.setSelectionRange(...inputSelection);
  }, [inputSelection]);
  return <>
      <Container>
        <RootURL />
        <StyledTextInput ref={inputRef} aria-invalid={errors.length > 0} aria-label={I18n.t('publisher.account_settings.link_label')} {...fieldProps} onChange={onChange} onFocus={onFocus} />
      </Container>
      <StatusContainer>
        {(showValidationStatus || errors.length > 0) && <ValidationStatus isLoading={formIsValidating} errors={errors} />}
      </StatusContainer>
    </>;
};

require("./slug-field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./slug-field.js");